<div class="mat-drawer-backdrop" (click)="_onBackdropClicked()" [class.mat-drawer-shown]="_isShowingBackdrop()"></div><ng-content select="mat-sidenav"></ng-content><ng-content select="mat-sidenav-content"></ng-content><mat-sidenav-content *ngIf="!_content" cdkScrollable><ng-content></ng-content></mat-sidenav-content>


// WEBPACK FOOTER //
// ./node_modules/@angular/material/sidenav/typings/index.d.ts.MatSidenavContainer.html